module.exports = __webpack_public_path__ + "static/media/zoom.b3bf91fb.png";